<template>
  <b-card no-body class="search-panel">
    <b-card-body>
      <div class="search-panel__controls">
        <!-- export port/berth search -->
        <port-search-widget
          title="Load port"
          :search-results="searchFields.load.results"
          :search-value="searchFields.load.value"
          @input="($event) => handleSearchInput('load', $event)" />

        <div class="divider">
          <i class="fa fa-2x fa-long-arrow-right"></i>
        </div>

        <!-- import port/berth search -->
        <port-search-widget
          title="Discharge port"
          :search-results="searchFields.discharge.results"
          :search-value="searchFields.discharge.value"
          @input="($event) => handleSearchInput('discharge', $event)" />
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import getNested from 'lodash-es/get';
import intersectionBy from 'lodash-es/intersectionBy';
import PortSearchWidget from '@/components/portscomparison/PortSearchWidget';
import { mapActions, mapGetters } from 'vuex';
import { defaultPortSearchResults } from '@/shared/constants/ports';


export default {
  name: 'search-panel',

  components: {
    PortSearchWidget,
  },

  data() {
    return {
      filtersReady: false,
      searchFields: this.getDefaultSearchFields(),
    };
  },

  methods: {
    ...mapActions('api/presets', [
      'updateCurrentFilterSettings',
    ]),

    getDefaultSearchFields() {
      return {
        load: {
          value: null,
          results: defaultPortSearchResults,
        },
        discharge: {
          value: null,
          results: defaultPortSearchResults,
        },
      };
    },

    handleSearchInput(direction, searchData) {
      this.searchFields[direction] = searchData;
      this.$emit('input', {direction, ...searchData});
    },

    setDefaultValues() {
      this.searchFields = this.getDefaultSearchFields();
    },
  },

  computed: {
    ...mapGetters('api/presets', ['getActivePreset']),
  },

  watch: {
    selectedEntities(values) {
      // sync filter-panel berthIds with search-multiselect values
      this.searchValue = intersectionBy(this.searchResults, values, 'id');
    },

    searchFields: {
      // track current filters to presets subsystem
      immediate: true,
      deep: true,
      handler: async function() {
        await this.updateCurrentFilterSettings({
          path: this.$route.path,
          parameters: {
            searchPanel: this.searchFields,
          },
        });
      },
    },

    getActivePreset: {
      immediate: true,
      handler: function (preset) {
        if(preset && this.$route.path !== preset.viewName) {
          return;
        }

        if(!this.filtersReady && !preset) {
          this.filtersReady = true;
          this.setDefaultValues();
        }

        if(preset) {
          this.searchFields = getNested(preset, 'params.searchPanel', {});
        }
      },
    },
  },
}
</script>

<style scoped>
.search-multiselect.multiselect--active {
  min-width: 600px !important;
  transition: all 0.2s;
}
</style>

<style scoped lang="scss">
  .w-10 {
    width: 10%;
  }

  .w-25 {
    width: 25%;
  }

  .divider {
    margin: 0 10px;
    color: rgba(184, 184, 184, 0.4);
  }

  .search-panel {
    margin: 0 0 0.5rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .card-body {
      padding: 0.5rem;
    }

    &__title {
      font-size: 18px;

    }
    &__controls {
      display: flex;
      align-items: center;

      .search-multiselect {
        margin-right: 20px;
        transition: all 0.2s;
        min-width: 300px;

        &__option {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }
      }
    }
  }

  .choice-button,
  .choice-button:focus,
  .choice-button:active {
    min-width: 60px;
    outline: none !important;
    box-shadow: none !important;
    background-color: #1d3d4f !important;
    border-color: #1d3d4f !important;

    &.active {
      background-color: #3b89a1 !important;
      border-color: #3b89a1 !important;
    }
  }

</style>
